/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, March 2023
 * @flow
 */

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SideDrawer from '../../../../components/SideDrawer';
import FireboardUtils from '../../../../util/fireboard-util';
import CommonUtil from '../../../Fireboard/common';
import MenuUtils from '../../../../util/menu-utils';
import FBCheckDetails from '../../../Fireboard/components/Body/CheckDetails';
import classes from './CheckDetails.module.css';
import Tabs from '../../../../components/Tabs';
import Aux from '../../../../components/AuxComponent';

const CheckDetails = props => {
  const {
    showCheckDetails,
    onToggleCheckDetailsPopup,
    selectedTableChecks,
  } = props;
  const [selectedCheck, setSelectedCheck] = useState({});

  useEffect(() => {
    if (Array.isArray(selectedTableChecks) && selectedTableChecks.length > 0)
      setSelectedCheck(selectedTableChecks[0]);
  }, [selectedTableChecks]);

  const { storeInfo, deviceApi, currencyInfo } = useSelector(state => state);
  const { iso2, currency } = currencyInfo || {};
  const { deviceGroup } = deviceApi?.data || {};
  const enableAgeVerification = (deviceGroup && deviceGroup?.fireBoardSettings)
    ? deviceGroup?.fireBoardSettings?.enableAgeVerification
    : false;
  const enableAgeRestrictedOrderingForSeat = (deviceGroup && deviceGroup?.fireBoardSettings)
    ? deviceGroup?.fireBoardSettings?.enableAgeRestrictedOrderingForSeat
    : false;
  const enableAgeRestrictedOrderingForCheck = (deviceGroup && deviceGroup?.fireBoardSettings)
    ? deviceGroup?.fireBoardSettings?.enableAgeRestrictedOrderingForCheck
    : false;
  const { enableGpsLocation, latitude, longitude, serverAppFeatures } = storeInfo?.data || {};
  const { supportsTipsOnTotalAmount = false, suppressTipsOnFireBoard = false } = serverAppFeatures || {};

  const dummyFn = () => { };

  const onTabChange = id => {
    if (Array.isArray(selectedTableChecks)) {
      const check = selectedTableChecks.find(el => el.id === id);
      if (check) setSelectedCheck(check);
    }
  };

  const getItems = (check) => {
    let items = check && check.items;
    let pendingItems = [];
    if (CommonUtil.getOrderTypeFromSourceType(check.sourceType) === 'POS') {
      items = FireboardUtils.updatePOSItems(check);
      const pendingCheckItems = MenuUtils.getPendingItemsFromCheck(check);
      pendingItems = FireboardUtils.updatePendingPOSItems(pendingCheckItems, check);
    }
    return { items, pendingItems };
  };

  return (
    <SideDrawer
      isOpen={showCheckDetails}
      onRequestClose={onToggleCheckDetailsPopup}
      width='35%'
      from='right'
    >
      <Tabs
        activeTab={selectedCheck?.id}
        onTabChange={onTabChange}
        tabsContainerStyle={classes.tabsContainer}
        tabsStyle={classes.ulStyle}
      >
        {selectedTableChecks.map(check => {
          const { items, pendingItems } = getItems(check);
          return (
            <Aux id={check.id} name={check.number} key={`id-${check.id}`}>
              <FBCheckDetails
                checkDetailsStyles={classes.detailsContainer}
                selectedItem={check}
                items={items}
                supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
                showMemberDetailPopup={memberId => dummyFn(memberId)}
                onPrintPress={(type, printMeta) => dummyFn(type, printMeta)}
                getManagerNotifications={[]}
                pendingItems={pendingItems}
                currency={currency}
                iso2={iso2}
                suppressTipsOnFireBoard={suppressTipsOnFireBoard}
                enableGpsLocation={false}
                latitude={latitude}
                longitude={longitude}
                viewGuestLocationOnMap={dummyFn}
                onRequestRefreshGuestGPS={dummyFn}
                onClickSms={(seatId) => dummyFn(seatId)}
                openCaptureSeatNamePopup={(seatId) => dummyFn(seatId)}
                enableAgeRestrictedOrderingForSeat={enableAgeRestrictedOrderingForSeat}
                onUpdateAgeRestrictedItemsForSeat={(seatId, disableAgeRestricted) => dummyFn(seatId, disableAgeRestricted)}
                orderPendingItems={pendingItems}
                sendPendingItems={dummyFn}
                enableAgeVerification={enableAgeVerification}
                enableAgeRestrictedOrderingForCheck={enableAgeRestrictedOrderingForCheck}
              />
            </Aux>
          )
        })}
      </Tabs>
    </SideDrawer>
  );
};

export default CheckDetails;
